<template>
    <div class="detail-page">
        <div class="banner">
            <img v-if="showType === 1" :src="gameImg" alt="游戏图片" draggable="false" />
            <video v-else-if="showType === 2" :src="gameVideo" muted autoplay loop></video>
            <div class="cover-bg">
                <div class="left"></div>
                <div class="right"></div>
                <div class="bottom"></div>
                <div class="center"></div>
            </div>
            <div class="cover">
                <div class="cover-inner">
                    <div class="left-info">
                        <div class="game-cn-name">{{ leftGameInfo.zh_name }}</div>
                        <div class="game-english-name">{{ leftGameInfo.en_name }}</div>
                        <div class="icon-wrap">
                            <div class="icon-type">
                                <div class="icon-div icon1"></div>
                                <div class="icon-text">
                                    <p class="p1">一键开玩</p>
                                    <p class="p2">快速启动</p>
                                </div>
                            </div>
                            <div class="icon-type">
                                <div class="icon-div icon2"></div>
                                <div class="icon-text">
                                    <p class="p1">平台保障</p>
                                    <p class="p2">金牌客服售后无忧</p>
                                </div>
                            </div>
                            <div class="icon-type">
                                <div class="icon-div icon3"></div>
                                <div class="icon-text">
                                    <p class="p1">正品无忧</p>
                                    <p class="p2">官方授权账号</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-info">
                        <!-- 显示价格 -->
                        <template v-if="leftGameInfo.type === 1">
                            <div class="price-wrap">
                                <div class="icon">
                                    <p class="p1">直降</p>
                                    <p class="p2">{{ showDiscount }}%</p>
                                </div>
                                <span class="yuan">￥</span>
                                <span class="cur-price">{{ leftGameInfo.enable_sp_low_cur_price }}</span>
                                <div class="steam-price">
                                    <p>steam售价</p>
                                    <p class="p2">原价:￥{{ leftGameInfo.steam_price }}</p>
                                </div>
                            </div>
                        </template>
                        <!-- 显示"会员免费玩文字" -->
                        <template v-if="leftGameInfo.type === 2">
                            <div class="free-wrap">
                                <div class="icon">
                                    <p>会员</p>
                                    <p>免费玩</p>
                                </div>
                                <div class="steam-price">
                                    <p>steam售价</p>
                                    <p class="p2">原价:￥{{ leftGameInfo.steam_price }}</p>
                                </div>
                            </div>
                        </template>
                        <!-- 立即购买和会员免费玩按钮 -->
                        <div class="btn-section" v-if="leftGameInfo.type !== 0">
                            <div @click="dlClient('click_single')" data-agl-cvt="6" class="btn buy">{{ leftGameInfo.type === 2 ? '立即游玩' : '立即购买' }}</div>
                            <div @click="dlClient('click_vip')" data-agl-cvt="6" class="btn free">会员免费玩</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="intro-img" @click="dlClient" data-agl-cvt="6"></div>
        <div class="intro-game">
            <div class="left-info">
                <div class="title">
                    <span class="sp1">游戏简介</span>
                    <span class="sp2">Game Introduction</span>
                </div>
                <div class="title-line">
                    <div class="active-line"></div>
                </div>
                <div class="game-intro" v-html="gameInfo.introduce"></div>
            </div>
            <div class="right-info">
                <div class="title">
                    <span class="sp1">配置要求</span>
                    <span class="sp2">Configuration Requirements</span>
                </div>
                <div class="title-line">
                    <div class="active-line"></div>
                </div>
                <div class="low-disp module-info">
                    <div class="item-wrap">
                        <div class="item" v-for="(item, index) in lowSysreq" :key="index">
                            <div class="item-title">{{ item.key }}：</div>
                            <div class="item-con">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getGameInfo, getLocalGameList } from '@/http/api/game'
import { Decimal } from 'decimal.js'

export default {
    name: 'Landpage',
    metaInfo() {
        return {
            title: `${this.leftGameInfo.zh_name} 中文正版下载免费畅玩`,
            meta: [
                {
                    name: 'keywords',
                    content: `【${this.leftGameInfo.zh_name}】正版购买，【${this.leftGameInfo.zh_name}】怎么下载，【${this.leftGameInfo.zh_name}】史低，【${this.leftGameInfo.zh_name}】平台`
                },
                {
                    name: 'description',
                    content: `乐速盒子集合全球3A大作，了解【${this.leftGameInfo.zh_name}】如何购买，【${this.leftGameInfo.zh_name}】怎么下载，可以来乐速盒子平台，会员免费畅玩【${this.leftGameInfo.zh_name}】`
                }
            ]
        }
    },
    data() {
        return {
            game_id: 0,
            channel: '',
            hotGameInfo: {},
            gameInfo: {},
            lowSysreq: [],
            gameImg: '',
            gameVideo: '',
            showType: -1, // 1--图片 2--视频
            activeSwiperIndex: 0,
            activeSwiper: {},
            leftGameInfo: {
                type: 0, // 1--有最低价和现价 2--》显示'会员免费玩'文字
                zh_name: '',
                en_name: '',
                steam_price: '',
                enable_sp_low_cur_price: '' // 上架规格里面现价最低的
            },
            swiperDataList: []
        }
    },
    computed: {
        showDiscount() {
            const { enable_sp_low_cur_price, steam_price } = this.leftGameInfo
            let discount = '0'
            if (steam_price && enable_sp_low_cur_price) {
                // 差价
                const priceDiff = Decimal(steam_price).minus(enable_sp_low_cur_price)
                // steam_price为0时或者差价小于等于0，显示0
                if (Decimal(steam_price).eq(0) || priceDiff.lte(Decimal(0))) {
                    discount = 0
                } else {
                    // 计算折扣 保留一位小数
                    discount = priceDiff.dividedBy(Decimal(steam_price)).times(100).toNumber().toFixed(1)
                }
            }
            return discount
        }
    },
    created() {
        this.game_id = this.$route.query.game_id || this.$cookies.get('box_website_game_id')
        this.channel = this.$route.query.channel || this.$cookies.get('steamf-gamebox-channel')
        this.goods_id = this.$route.query.goods_id || 0
        this.getGameInfo()
    },
    methods: {
        filterImg(value) {
            return this.$Utils.filterImgUrl(value)
        },
        filterVideo(value) {
            return this.$Utils.filterVideoUrl(value)
        },
        getGameInfo() {
            getGameInfo({ id: this.game_id })
                .then((res) => {
                    if (res.code == 200 && res.data.game_id) {
                        this.gameInfo = res.data
                        this.formatSysreq(this.gameInfo.sysreq)

                        const screenshot_list = this.gameInfo.screenshot_list
                        const hasVideo = screenshot_list.filter((item) => item.type == 2)
                        const hasImg = screenshot_list.filter((item) => item.type == 1)
                        if (hasVideo.length > 0) {
                            this.showType = 2
                            const firstVideo = hasVideo[0].video
                            this.gameVideo = this.filterVideo(firstVideo)
                        } else if (hasImg.length > 0) {
                            this.showType = 1
                            const firstImg = hasImg[0].url
                            this.gameImg = this.filterImg(firstImg)
                        }

                        this.leftGameInfo.zh_name = this.gameInfo.title
                        this.leftGameInfo.en_name = this.gameInfo.english_title
                        this.leftGameInfo.steam_price = this.gameInfo.original_price || '0.00'
                        // 根据游戏id查找关联的盒子商品
                        this.getLocalGameList(this.game_id)
                    }
                })
                .catch(() => {})
        },
        formatSysreq(value) {
            try {
                let tempValue = JSON.parse(value),
                    tempArr = []

                tempValue.forEach((v) => {
                    let key = Object.keys(v)[0]
                    if (key && v[key]) {
                        tempArr.push({ key, value: v[key] })
                    }
                })

                this.lowSysreq = tempArr
            } catch (error) {}
        },
        dlClient(click_str) {
            if (click_str === 'click_single') {
                // 立即购买
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 13 })
            } else if (click_str === 'click_vip') {
                // 会员免费玩
                this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 14 })
            }
            this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 3 })

            if (click_str === 'click_single' && this.leftGameInfo.type !== 2) {
                this.$BuyVipDialog.show(this.gameInfo)
            } else {
                this.$EventBus.$emit('dl-client', 'landpage-banner')
            }
        },
        calcGameInfo(item) {
            const goods_list = [...item]
            // 判断上架状态的商品里面是否有可用的规格
            const everySpDisabled = goods_list.every((v) => !v.goodsSpecifications)
            if (!everySpDisabled) {
                // 获取所有的开启单独售卖的商品规格
                const allSp = goods_list.reduce((pre, cur) => {
                    if (Array.isArray(cur.goodsSpecifications) && cur.goodsSpecifications.length) {
                        pre.push(...cur.goodsSpecifications)
                    }
                    return pre
                }, [])
                // 没有开启售卖的规格，那就显示会员免费玩
                if (allSp.length === 0) {
                    this.leftGameInfo.type = 2
                    this.setGameIdAndGoodsId(this.game_id, goods_list[0].id)
                } else {
                    // 获取规格里面的最低价
                    const minSp = allSp.sort((a, b) => {
                        return a.current_price - b.current_price
                    })[0]

                    // 如果最低价的规格没有开启售卖，那就显示会员免费玩
                    if (minSp.is_sell !== 1) {
                        this.leftGameInfo.type = 2
                        this.setGameIdAndGoodsId(this.game_id, goods_list[0].id)
                    } else {
                        this.leftGameInfo.enable_sp_low_cur_price = minSp.current_price
                        // 把规格价格最低的对应的商品ID存储到 sessionStorage 中，因为页面显示的价格就是最低的价格，
                        // 下载的goods_id也应该是这个规格对应的商品
                        this.setGameIdAndGoodsId(this.game_id, minSp.g_id || 0)
                        this.leftGameInfo.type = 1
                    }
                }
            } else {
                this.setGameIdAndGoodsId(this.game_id, goods_list[0].id)
                this.leftGameInfo.type = 2
            }
        },
        setGameIdAndGoodsId(game_id, goods_id) {
            // 从 sessionStorage 中获取游戏ID和商品ID，存储的值为{游戏id:商品id}
            // 如果不存在，则初始化为一个空对象
            let gameIdAndGoodsId = sessionStorage.getItem('gameIdAndGoodsId'),
                saveValue = {},
                tempValue = {}

            if (gameIdAndGoodsId) {
                try {
                    const jsonObj = JSON.parse(gameIdAndGoodsId)
                    if (jsonObj instanceof Object) {
                        saveValue = jsonObj
                    }
                } catch (error) {}
            }

            tempValue[game_id] = goods_id
            sessionStorage.setItem('gameIdAndGoodsId', JSON.stringify({ ...saveValue, ...tempValue }))
        },
        getLocalGameList(game_id) {
            const query = {
                steamAppid: '[]',
                game_id
            }

            getLocalGameList(query).then((res) => {
                if (res.code == 200 && res.data) {
                    let goodsList = res.data.list?.[0]?.goodsList || []
                    // 会存在多个盒子商品关联同一个游戏的问题，这里从地址上获取的商品ID进行过滤
                    let isExistGoodsId = goodsList.findIndex((item) => item.id == this.goods_id)
                    if (isExistGoodsId !== -1) {
                        goodsList = goodsList.filter((item) => item.id == this.goods_id)
                    }
                    if (goodsList.length) {
                        this.calcGameInfo(goodsList)
                    } else {
                        // 没有关联任何盒子商品
                        this.leftGameInfo.enable_sp_low_cur_price = '0.00'
                        this.setGameIdAndGoodsId(this.game_id, 0)
                    }
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.detail-page {
    .banner {
        position: relative;
        height: 710px;
        max-width: 1920px;
        margin: 0 auto;

        img,
        video {
            margin: 0 auto;
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .cover-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .left {
                background-image: linear-gradient(90deg, rgba(18, 18, 18, 0.98), rgba(18, 18, 18, 0.65) 35%, transparent);
                height: 100%;
                left: 0px;
                position: absolute;
                top: 0px;
                width: 500px;
            }

            .right {
                background-image: linear-gradient(-90deg, rgba(18, 18, 18, 0.98), rgba(18, 18, 18, 0.65) 35%, transparent);
                height: 100%;
                position: absolute;
                right: 0px;
                top: 0px;
                width: 500px;
            }

            .bottom {
                background-image: linear-gradient(360deg, rgb(18, 18, 18), rgba(18, 18, 18, 0.95) 16%, transparent);
                bottom: 0px;
                height: 240px;
                position: absolute;
                width: 100%;
            }

            .center {
                background-color: rgb(14, 26, 32);
                height: 100%;
                left: 0px;
                opacity: 0;
                position: absolute;
                top: 0px;
                transition: opacity 0.3s;
                width: 100%;
            }
        }

        .cover {
            position: absolute;
            top: 0;
            padding-top: 80px;
            right: 0;
            width: 100%;
            height: 100%;
            z-index: 2;

            .cover-inner {
                position: relative;
                margin: 0 auto;
                height: 630px;
                width: 1320px;

                .left-info {
                    position: absolute;
                    top: 387px;
                    left: 0;

                    .game-cn-name {
                        color: rgb(255, 255, 255);
                        font-size: 40px;
                        font-weight: 700;
                        line-height: 60px;
                        height: 60px;
                    }

                    .game-english-name {
                        color: rgb(166, 166, 166);
                        font-size: 20px;
                        line-height: 30px;
                        height: 30px;
                    }

                    .icon-wrap {
                        margin-top: 66px;
                        display: flex;

                        .icon-type {
                            display: flex;
                            margin-right: 32px;

                            .icon-div {
                                width: 38px;
                                height: 38px;
                                margin-right: 10px;

                                &.icon1 {
                                    background: url(../../assets/landpage/icon1.png) center/100% no-repeat;
                                }

                                &.icon2 {
                                    background: url(../../assets/landpage/icon2.png) center/100% no-repeat;
                                }

                                &.icon3 {
                                    background: url(../../assets/landpage/icon3.png) center/100% no-repeat;
                                }
                            }

                            .icon-text {
                                .p1 {
                                    color: #ffffff;
                                    font-size: 14px;
                                    line-height: 21px;
                                }

                                .p2 {
                                    color: #a6a6a6;
                                    font-size: 12px;
                                    line-height: 18px;
                                }
                            }
                        }
                    }
                }

                .right-info {
                    position: absolute;
                    top: 396px;
                    right: 0;

                    .price-wrap,
                    .free-wrap {
                        .steam-price {
                            padding-top: 23px;
                            color: rgb(166, 166, 166);
                            font-size: 16px;

                            p {
                                line-height: 24px;
                            }

                            .p2 {
                                text-decoration: line-through;
                            }
                        }
                    }

                    .price-wrap {
                        margin-top: 8px;
                        margin-bottom: 19px;
                        display: flex;
                        justify-content: flex-end;
                        padding-right: 99px;

                        .icon {
                            margin-right: 8px;
                            width: 73px;
                            height: 83px;
                            background: url(../../assets/discount-icon.png) center/100% no-repeat;

                            .p1 {
                                padding: 21px 0 3px;
                                text-align: center;
                                color: rgb(255, 255, 255);
                                font-size: 15px;
                                font-weight: 700;
                                line-height: 20px;
                            }

                            .p2 {
                                text-align: center;
                                color: rgb(255, 255, 255);
                                font-size: 18px;
                                font-weight: 700;
                                line-height: 24px;
                            }
                        }

                        .yuan,
                        .cur-price {
                            font-weight: bold;
                            color: rgb(0, 235, 87);
                        }

                        .yuan {
                            margin-right: 4px;
                            padding-top: 39px;
                            font-size: 24px;
                            line-height: 36px;
                        }

                        .cur-price {
                            margin-right: 8px;
                            padding-top: 12px;
                            font-size: 48px;
                            font-style: normal;
                            line-height: 72px;
                        }
                    }

                    .free-wrap {
                        margin-top: 8px;
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        padding-right: 37px;

                        .icon {
                            margin-right: 8px;
                            width: 72px;
                            height: 83px;
                            background: url(../../assets/free-icon.png) center/100% no-repeat;
                            color: #7c1900;
                            font-size: 24px;
                            font-weight: 700;
                            line-height: 51px;
                            padding-top: 24px;

                            p {
                                text-align: center;
                                font-size: 15px;
                                line-height: 20px;
                                font-weight: bold;
                            }
                        }

                        .steam-price {
                            padding-top: 0;
                        }
                    }

                    .btn-section {
                        display: flex;
                        margin-right: -12px;

                        .btn {
                            width: 258px;
                            height: 84px;
                            font-size: 24px;
                            font-weight: bold;
                            line-height: 76px;
                            text-align: center;
                            cursor: pointer;

                            &.buy {
                                color: #ffffff;
                                margin-right: 8px;
                                background: url(../../assets/index/buy.png) left top no-repeat;

                                &:hover {
                                    background-image: url(../../assets/index/buy-h.png);
                                }
                            }

                            &.free {
                                color: #7c1900;
                                background: url(../../assets/index/free.png) left top no-repeat;

                                &:hover {
                                    background-image: url(../../assets/index/free-h.png);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .intro-img {
        cursor: pointer;
        margin: 60px auto 98px;
        width: 1321px;
        height: 118px;
        background: url(../../assets/landpage/intro.png) center/100% no-repeat;

        &:hover {
            background-image: url(../../assets/landpage/intro-h.png);
        }
    }

    .intro-game {
        display: flex;
        margin: 0 auto;
        padding: 0 46px;
        width: @main-width;

        .title {
            span {
                vertical-align: bottom;
            }

            .sp1 {
                font-weight: bold;
                font-size: 30px;
                line-height: 30px;
                color: #ffffff;
                background: linear-gradient(0deg, #ffffff 34.2041015625%, #c1c6c3 100%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .sp2 {
                position: relative;
                font-size: 16px;
                color: @color-txt-normal;
                margin-left: 14px;
                top: 5px;
            }
        }

        .title-line {
            position: relative;
            margin-top: 12px;
            margin-bottom: 40px;
            width: 294px;
            height: 1px;
            background-color: @bg-color-00;

            .active-line {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 119px;
                height: 3px;
                background: #00eb57;
                border-radius: 2px;
            }
        }

        .left-info {
            width: 810px;

            .game-intro {
                margin-top: 20px;
                padding-bottom: 10px;
                color: @color-txt-normal !important;
                line-height: 1.5;

                /deep/ p,
                /deep/ b,
                /deep/ i,
                /deep/ s,
                /deep/ em,
                /deep/ a,
                /deep/ font,
                /deep/ span,
                /deep/ ul,
                /deep/ li,
                /deep/ table,
                /deep/ tr,
                /deep/ td,
                /deep/ button,
                /deep/ input,
                /deep/ select,
                /deep/ textarea,
                /deep/ form {
                    color: @color-txt-normal !important;
                }

                /deep/ h1,
                /deep/ h2,
                /deep/ h3,
                /deep/ h4,
                /deep/ h5,
                /deep/ h6,
                /deep/ strong {
                    color: #fff !important;
                }

                /deep/ img,
                /deep/ audio,
                /deep/ video {
                    max-width: 100%;
                }
            }
        }

        .right-info {
            margin-left: 63px;
            width: 352px;

            .module-info {
                .title {
                    font-size: 16px;
                    line-height: 16px;
                    margin-bottom: 30px;
                }

                .item-wrap {
                    .item {
                        display: flex;
                        font-size: 14px;
                        line-height: 18px;
                        margin-bottom: 18px;

                        .item-title {
                            color: @color-txt-normal;
                        }

                        .item-con {
                            flex: 1;
                            color: @bg-color-cc;
                        }

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>
